<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Actions</th>
            <th class="text-left">
              Name
            </th>
            <th class="text-left">
              Email
            </th>
            <th class="text-left">
              Roles
            </th>
            <th class="text-left">
              Is Active
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user in users"
            :key="user.id">
            <td>
              <v-icon
                small
                class="mr-2"
                title="Edit user"
                @click="editUser(user)">mdi-pencil
              </v-icon>
            </td>
            <td>{{ user.givenName + ' ' + user.familyName }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.roles.join(', ')}}</td>
            <td><v-checkbox v-model="user.isActive" readonly></v-checkbox></td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">User Details</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="First name"
                  required
                  dense
                  v-model="currentUser.familyName"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Given name"
                  required
                  dense
                  v-model="currentUser.givenName"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Email"
                  required
                  dense
                  v-model="currentUser.email"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                    :items="companies"
                    item-text="companyName"
                    item-value="companyId"
                    label="Company"
                    outlined
                    dense
                    v-model="currentUser.companyId">
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                    :items="versionOneUsers"
                    :item-text="item => `${item.firstName},
                      ${item.surname};
                      ${item.email}`"
                    item-value="userId"
                    label="Version One User"
                    single-line
                    outlined
                    dense
                    v-model="currentUser.userInfoUserId">
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox
                  dense
                  label="Is active"
                  v-model="currentUser.isActive"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
               <v-col cols="12">
                 <v-select
                  v-model="currentUser.roles"
                  :items="roles"
                  item-text="roleName"
                  item-value="roleValue"
                  :menu-props="{ maxHeight: '400' }"
                  label="Roles"
                  multiple
                  chips
                  hint="Select the users roles"
                  persistent-hint></v-select>
               </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="cancel()">
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="saveUser()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'users',
  components: {
  },
  data: () => ({
    users: [],
    roles: [],
    companies: [],
    versionOneUsers: [],
    dialog: false,
    currentUser: {},
  }),
  computed: {
    ...mapGetters(['USERS', 'ROLES', 'IS_ADMINISTRATOR', 'COMPANIES', 'VERSION_ONE_USERS']),
    // The `mapFields` function takes an array of
    // field names and generates corresponding
    // computed properties with getter and setter
    // functions for accessing the Vuex store.
    ...mapFields([
    ]),
  },
  mounted() {
    this.GET_USERS()
      .then(() => {
        this.users = this.USERS;
        this.roles = this.ROLES;
        this.companies = this.COMPANIES;
        this.versionOneUsers = this.VERSION_ONE_USERS;
        this.isLoading = false;
      },
      (error) => {
        this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  },
  methods: {
    ...mapActions(['GET_USERS', 'SAVE_USER']),
    editUser(user) {
      this.currentUser = user;
      this.dialog = true;
    },
    saveUser() {
      this.SAVE_USER(this.currentUser)
        .then(() => {
          this.users = this.USERS;
          this.roles = this.ROLES;
          this.dialog = false;
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    cancel() {
      this.dialog = false;
    },
  },
};
</script>
<style scoped>

</style>
